"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Load styles
require("../scss/style.scss");
// Load components
require("./components");
// Load plugins
require("./plugins");
